<app-menu></app-menu>
<app-login-validation></app-login-validation>

<div class="page">
  <div class="container">

    <h1 class="page-title">Carteira</h1>

    <!-- Cards superiores -->
    <div class="summary-cards" *ngIf="summary">
      <div class="card">
        <div class="label">Valor total em vendas</div>
        <div class="value">{{ formatBRL(summary.totalSalesValue) }}</div>
      </div>

      <div class="card">
        <div class="label">
          Total na carteira
          <mat-icon class="help-icon" [matMenuTriggerFor]="walletHelp"
                    matTooltip="Ver detalhamento" aria-label="Detalhamento dos valores">help_outline</mat-icon>
        </div>
        <div class="value">{{ formatBRL(summary.totalInWallet) }}</div>
      </div>

      <div class="card">
        <div class="label">Disponível para retirada</div>
        <div class="value">{{ formatBRL(summary.availableForWithdrawal) }}</div>
        <div class="hint">Saque mínimo {{ formatBRL(summary.minWithdrawalAmount) }}</div>
      </div>

      <div class="cta">
        <button mat-raised-button color="primary"
                (click)="onRequestPix()"
                [disabled]="!canRequestPix()">
          Retirar tudo
        </button>
      </div>
    </div>

    <mat-menu #walletHelp="matMenu" class="wallet-help-menu">
      <div class="help-popover" (click)="$event.stopPropagation()" *ngIf="summary">
        <div class="help-block">
          <div class="help-title">Na carteira agora</div>
          <div class="help-line"><span>Bruto</span><span>{{ formatBRL(summary.inWallet.gross) }}</span></div>
          <div class="help-line"><span>− Imposto</span><span>{{ formatBRL(summary.inWallet.tax) }}</span></div>
          <div class="help-line"><span>− Produção</span><span>{{ formatBRL(summary.inWallet.production) }}</span></div>
          <div class="help-line total"><span>= Seu líquido</span><span>{{ formatBRL(summary.inWallet.net) }}</span></div>
        </div>
        <div class="help-block">
          <div class="help-title">Vitalício</div>
          <div class="help-line"><span>Bruto</span><span>{{ formatBRL(summary.lifetime.gross) }}</span></div>
          <div class="help-line"><span>− Imposto</span><span>{{ formatBRL(summary.lifetime.tax) }}</span></div>
          <div class="help-line"><span>− Produção</span><span>{{ formatBRL(summary.lifetime.production) }}</span></div>
          <div class="help-line total"><span>= Líquido vitalício</span><span>{{ formatBRL(summary.lifetime.net) }}</span></div>
          <div class="help-sub">Na carteira {{ formatBRL(summary.inWallet.net) }} · Já sacado {{ formatBRL(summary.withdrawnNet) }}</div>
        </div>
      </div>
    </mat-menu>

    <mat-divider></mat-divider>

    <!-- Solicitações em trânsito -->
    <section class="section">
      <h2 class="section-title">Solicitações em trânsito</h2>

      <ng-container *ngIf="inTransit?.items?.length; else noTransit">
        <div class="table">
          <div class="t-head">
            <div class="t-col col-date">Data</div>
            <div class="t-col col-pix">Chave PIX</div>
            <div class="t-col col-amount">Valor</div>
            <div class="t-col col-status">Status</div>
          </div>
          <div class="t-row" *ngFor="let r of inTransit?.items">
            <div class="t-col col-date">{{ formatDate(r.requestedAt) }}</div>
            <div class="t-col col-pix">{{ r.pix }}</div>
            <div class="t-col col-amount">{{ formatBRL(r.amount) }}</div>
            <div class="t-col col-status">
              <span class="status-pill status-pending" *ngIf="r.status === 0">{{ r.statusLabel }}</span>
              <span class="status-pill status-processing" *ngIf="r.status === 1">{{ r.statusLabel }}</span>
              <span class="status-pill status-paid" *ngIf="r.status === 2">{{ r.statusLabel }}</span>
              <span class="status-pill status-rejected" *ngIf="r.status === 3">{{ r.statusLabel }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noTransit>
        <div class="empty">
          <div class="empty-title">Sem transferências em trânsito</div>
          <div class="empty-sub">Não existem transferências pendentes</div>
        </div>
      </ng-template>
    </section>

    <mat-divider></mat-divider>

    <!-- Extrato -->
    <section class="section">
      <h2 class="section-title">Extrato</h2>

      <div class="table extrato-table" *ngIf="sales?.items?.length; else noSales">
        <div class="t-head">
          <div class="t-col col-title">Venda</div>
          <div class="t-col col-date">Data</div>
          <div class="t-col col-amount">Valor da venda</div>
          <div class="t-col col-amount">Você recebe</div>
          <div class="t-col col-status">Status</div>
          <div class="t-col col-actions"></div>
        </div>

        <ng-container *ngFor="let s of sales?.items">
          <div class="t-row sale-row" (click)="toggleSale(s.idKitPaymentItem)">
            <div class="t-col col-title">
              <mat-icon class="chev">{{ isExpanded(s.idKitPaymentItem) ? 'expand_more' : 'chevron_right' }}</mat-icon>
              {{ s.bookTitle }}
            </div>
            <div class="t-col col-date">{{ formatDate(s.paidAt) }}</div>
            <div class="t-col col-amount">{{ formatBRL(s.grossValue) }}</div>
            <div class="t-col col-amount">{{ formatBRL(s.netValue) }}</div>
            <div class="t-col col-status"><span class="status-pill" [ngClass]="'st-' + s.statusSummary">{{ s.statusLabel }}</span></div>
            <div class="t-col col-actions">
              <button mat-icon-button [matMenuTriggerFor]="saleInfo"
                      (click)="$event.stopPropagation()" matTooltip="Detalhes dos valores"
                      aria-label="Detalhes dos valores">
                <mat-icon>info_outline</mat-icon>
              </button>
              <mat-menu #saleInfo="matMenu">
                <div class="help-popover" (click)="$event.stopPropagation()">
                  <div class="help-title">{{ s.bookTitle }}</div>
                  <div class="help-line"><span>Preço unit. × {{ s.quantity }}</span><span>{{ formatBRL(s.priceUnit) }}</span></div>
                  <div class="help-line"><span>Bruto</span><span>{{ formatBRL(s.grossValue) }}</span></div>
                  <div class="help-line"><span>− Imposto ({{ s.taxPercent }}%)</span><span>{{ formatBRL(s.taxValue) }}</span></div>
                  <div class="help-line"><span>− Produção</span><span>{{ formatBRL(s.productionCost) }}</span></div>
                  <div class="help-line total"><span>= Você recebe</span><span>{{ formatBRL(s.netValue) }}</span></div>
                </div>
              </mat-menu>
            </div>
          </div>

          <div class="t-row parcela-row" *ngFor="let p of s.installments" [hidden]="!isExpanded(s.idKitPaymentItem)">
            <div class="t-col col-title parcela-label">Parcela {{ p.installmentNumber }}/{{ s.installmentCount }}</div>
            <div class="t-col col-date">{{ formatDate(p.availableDate) }}</div>
            <div class="t-col col-amount">—</div>
            <div class="t-col col-amount">{{ formatBRL(p.netValue) }}</div>
            <div class="t-col col-status"><span class="status-pill" [ngClass]="'st-' + p.status">{{ p.statusLabel }}</span></div>
            <div class="t-col col-actions"></div>
          </div>
        </ng-container>
      </div>

      <ng-template #noSales>
        <div class="empty">
          <div class="empty-title">Sem vendas</div>
          <div class="empty-sub">Você ainda não possui vendas registradas</div>
        </div>
      </ng-template>
    </section>

    <mat-divider></mat-divider>

    <!-- Histórico de retiradas -->
    <section class="section">
      <h2 class="section-title">Histórico de retiradas</h2>

      <div class="table" *ngIf="history?.items?.length; else noHistory">
        <div class="t-head">
          <div class="t-col col-date">Data</div>
          <div class="t-col col-pix">Chave PIX</div>
          <div class="t-col col-amount">Valor</div>
          <div class="t-col col-status">Status</div>
        </div>
        <div class="t-row" *ngFor="let r of history?.items">
          <div class="t-col col-date">{{ formatDate(r.requestedAt) }}</div>
          <div class="t-col col-pix">{{ r.pix }}</div>
          <div class="t-col col-amount">{{ formatBRL(r.amount) }}</div>
          <div class="t-col col-status">
            <span class="status-pill status-pending" *ngIf="r.status === 0">{{ r.statusLabel }}</span>
            <span class="status-pill status-processing" *ngIf="r.status === 1">{{ r.statusLabel }}</span>
            <span class="status-pill status-paid" *ngIf="r.status === 2">{{ r.statusLabel }}</span>
            <span class="status-pill status-rejected" *ngIf="r.status === 3">{{ r.statusLabel }}</span>
            <div *ngIf="r.receipt">
                <a [href]="r.receipt" download mat-icon-button
                    matTooltip="Baixar comprovante">
                    <mat-icon>download</mat-icon>
                </a>
            </div>
          </div>
        </div>
      </div>

      <ng-template #noHistory>
        <div class="empty">
          <div class="empty-title">Sem histórico</div>
          <div class="empty-sub">Você ainda não realizou retiradas</div>
        </div>
      </ng-template>
    </section>
  </div>
</div>

<app-footer></app-footer>
